import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=1798ecc0"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"
import style0 from "./Organization.vue?vue&type=style&index=0&id=1798ecc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports